<template>
  <Card class="moreInfoCard">
    <more-info-card-title
      slot="title"
      :title="title"
      :score="score"
      :combo_score="combo_score"
      :qrcode="qrcode"
    />
    <div
      style="display:flex;flex-direction: column;"
      :style="{ maxHeight: height - 151 + 'px', minHeight: '400px' }"
    >
      <div style="overflow: auto;flex:1;">
        <filter-form
          ref="filterForm"
          v-if="moreInfoType == 'filter'"
          :title="title"
          @valid="saveFilter"
        />
        <medical-form
          ref="medicalForm"
          v-if="moreInfoType !== 'filter'"
          :title="title"
          :record_time="record_time"
          :medical_record_id="medical_record_id"
          @valid="saveMedical"
        />
        <question-index
          ref="question"
          :questId="bind_code"
          :uniqueId="bind_unique"
          @change="show = false"
          @init="init"
          @error="loading = false"
          @success="success"
          @uniqued-result="setUniquedResult"
        ></question-index>
      </div>
      <div v-if="show" style="text-align: center;">
        <el-button type="info" round @click="cancel">取消</el-button>
        <el-button :loading="loading" type="primary" round @click="save">保存</el-button>
      </div>
    </div>
  </Card>
</template>
<script>
import questionIndex from '../../question/index.vue'
import filterForm from './filterForm.vue'
import medicalForm from './medicalForm.vue'
import moreInfoCardTitle from './moreInfoCardTitle.vue'
import { APP_QUESTION_URL } from '../../../utils/env'
import { formatDate } from '../../../utils/date'
export default {
  components: {
    questionIndex,
    filterForm,
    medicalForm,
    moreInfoCardTitle,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    bind_code: {
      type: String,
      default: '',
    },
    bind_unique: {
      type: String,
      default: '',
    },
    record_time: {
      type: String,
      default: '',
    },
    medical_record_id: {
      type: String | Number,
      default: '',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['moreInfoType'],
  data() {
    return {
      loading: false,
      show: false,
      height: '',
      score: '',
      combo_score: '',
    }
  },
  computed: {
    qrcode() {
      const cur = (this.$refs.medicalForm || {}).cur || {}
      let record_time
      let medical_record_id = ''
      if (cur.record_time) {
        record_time = cur.record_time
      } else {
        record_time = new Date()
      }
      if (cur.medical_record_id) {
        medical_record_id = cur.medical_record_id
      }
      let url =
        APP_QUESTION_URL +
        '?questId=' +
        this.bind_code +
        '&tenant=' +
        this.$store.state.tenant.tenant +
        '&uniqueId=' +
        this.bind_unique +
        '&extra=' +
        JSON.stringify(
          Object.assign(
            {},
            this.params,
            this.moreInfoType === 'filter'
              ? {
                  biz_type: 'filtrate',
                  channel: '二维码',
                }
              : {
                  record_time: formatDate(
                    record_time,
                    0,
                    'yyyy-MM-dd hh:mm:ss'
                  ),
                  medical_record_id,
                  biz_type: 'confirmed',
                  channel: '二维码',
                }
          )
        )
      return url
    },
  },
  watch: {
    bind_code() {
      this.show = false
      this.score = ''
      this.combo_score = ''
    },
    bind_unique() {
      this.show = false
      this.score = ''
      this.combo_score = ''
    },
  },
  mounted() {
    this.height = window.innerHeight - 126
  },
  methods: {
    setUniquedResult(res) {
      if (res.code === 0) {
        this.score = res.data.total_score
        this.combo_score = res.data.combo_score
      }
    },
    init() {
      this.show = true
    },
    cancel() {
      this.$emit('cancel')
    },
    save() {
      this.$emit('save')
    },
    saveFilter(params, type) {
      this.$refs.question.submitbtn(params, type)
    },
    saveMedical(params, type) {
      // this.loading = true;
      this.$refs.question.submitbtn(params, type)
    },
    submit() {
      if (this.moreInfoType === 'filter') {
        this.$refs.filterForm.validate(this.params, 'filtrate')
      } else {
        this.$refs.medicalForm.validate(this.params, 'confirmed')
      }
    },
    success() {
      this.loading = false
      this.$emit('success')
    },
  },
}
</script>
<style lang="less">
.moreInfoCard {
}
</style>
